<div>
    <ngb-accordion #a="ngbAccordion">
        <ngb-panel id="tutores-panel">
            <ng-template ngbPanelHeader>
                <div class="row tutores-panel">
                    <div class="d-flex align-items-center justify-content-between" style="border: none;">
                        <div class="d-flex align-items-center justify-content-start">
                            <div class="panel-item">
                                <p style="padding: 10px;" class="texto-card-tutor-indice">Tutor(A) {{indice+1}}</p>
                            </div>
                            <div class="panel-item">
                                <div class="image-cropper" placement="bottom">
                                    <img [src]="tutorData.urlPicture" alt="avatar" id="improfile" class="profile-pic">
                                </div>
                            </div>
                            <div class="panel-item">
                                <p style="padding: 10px;" class="texto-card-tutor flex-grow-1">{{tutorData.nombres}} {{tutorData.apellido_paterno}} {{tutorData.apellido_materno}}</p>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-end">
                            <!--                             <div class="panel-item">
                                <div class="p-0 bell-notify">
                                    <i class="fas fa-bell fa-2x"></i>
                                    <span class="badge"><b>{{notifyCont}}</b></span>
                                </div>
                            </div> -->
                            <div class="panel-item">
                                <button ngbPanelToggle class="btn btn-link p-0 button-toggle" (click)="changeText($event.target)">+</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template ngbPanelContent>
                <div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'">
                    <mat-spinner style="margin:0 auto;margin-top: 5px;"></mat-spinner>
                </div>
                <div class="row">
                    <div class="col-1" style="background-color: #7695fb; width: 160px;">
                        <div class="div" style="padding: 10px 0px 20px 20px">
                            <p style="color: white;"><b>Unidad Educativa</b></p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col-3">
                                <div class="row" style="padding: 5px;background-color: #d9e1fb;color: #7695fb;">
                                    <p style="text-align: center;"><b>Sesión 1</b></p>
                                </div>
                                <div class="row tutor-table-header">
                                    <div class="col">
                                        <p style="text-align: center;"><b>Estado</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Tiempo</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Satisfacción</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Acta</b></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row" style="padding: 5px;background-color: #eaeefb;color: #7695fb;">
                                    <p style="text-align: center;"><b>Sesión 2</b></p>
                                </div>
                                <div class="row tutor-table-header">
                                    <div class="col">
                                        <p style="text-align: center;"><b>Estado</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Tiempo</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Satisfacción</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Acta</b></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row" style="padding: 5px;background-color: #d9e1fb;color: #7695fb;">
                                    <p style="text-align: center;"><b>Sesión 3</b></p>
                                </div>
                                <div class="row tutor-table-header">
                                    <div class="col">
                                        <p style="text-align: center;"><b>Estado</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Tiempo</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Satisfacción</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Acta</b></p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="row" style="padding: 5px;background-color: #eaeefb;color: #7695fb;">
                                    <p style="text-align: center;"><b>Sesión 4</b></p>
                                </div>
                                <div class="row tutor-table-header">
                                    <div class="col">
                                        <p style="text-align: center;"><b>Estado</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Tiempo</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Satisfacción</b></p>
                                    </div>
                                    <div class="col">
                                        <p style="text-align: center;"><b>Acta</b></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-striped">
                    <div class="row tutor-table-row" *ngFor="let jardin of jardines">
                        <div class="col-1" style="width: 160px;">
                            <div class="div">
                                <p style="color: rgb(54, 52, 52);text-align: center;"><b>{{jardin.jardin}}</b></p>
                            </div>
                        </div>
                        <div class="col">
                            <div class="row" style="padding: 5px;">
                                <div class="col-3" *ngFor="let tutoria of jardin.tutorias">
                                    <div class="row">
                                        <div class="col" [ngSwitch]="tutoria.estadoTutoria">
                                            <p style="text-align: center;color: #ee366d;" *ngSwitchCase="estado[0]"><b>{{tutoria.estadoTutoria}}</b></p>
                                            <p style="text-align: center;color: #50c5be;" *ngSwitchCase="estado[1]"><b>{{tutoria.estadoTutoria}}</b></p>
                                            <p style="text-align: center;color: #47516a;" *ngSwitchCase="estado[2]"><b>{{tutoria.estadoTutoria}}</b></p>
                                            <p style="text-align: center;color: #6283ef;" *ngSwitchCase="estado[3]"><b>{{tutoria.estadoTutoria}}</b></p>
                                        </div>
                                        <div class="col">
                                            <p style="text-align: center;"><b>{{calcTime(tutoria.fechaInicioTutoria, tutoria.fechaFinTutoria)}} min.</b></p>
                                        </div>
                                        <div class="col">
                                            <p style="text-align: center;"><b>{{porcentajeEncuestaTutoria(tutoria.encuestaTutoria)}} %</b></p>
                                        </div>
                                        <div class="col">
                                            <div class="row">
                                                <div class="col">
                                                    <p style="color: #ee366d; text-align: right;"><b>NO</b></p>
                                                </div>
                                                <div class="col">
                                                    <mat-slide-toggle [disabled]="disabled" (click)="$event.preventDefault();" [ngModel]="isActa(tutoria.estadoTutoria)"></mat-slide-toggle>
                                                </div>
                                                <div class="col">
                                                    <p style="color: #7695fb;"><b>SÍ</b></p>
                                                </div>
                                                <div class="col">
                                                    <button class="btn btn-acta" (click)="showActaTutoria(tutoria.idJardinPeriodoTutoria)"> 
                                                        <i class="fas fa-download"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
</div>